
import LazyYoutube from './LazyYouTube';

export default function AboutUs({ aboutUsPage }) {
  let videoFile = null
  if (aboutUsPage.pageModules) {
    aboutUsPage.pageModules.map((module) => {
        if(module._type === 'videoBlock') {
          videoFile = module.videoFiles[0]
        }
    })
  }

  return (
    <div className="mx-2 md:mx-10 lg:mx-10 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="col-span-1 lg:col-span-3 order-first">
          <h2 className="text-3xl text-right font-semibold text-primary mb-10">{aboutUsPage.title}</h2>
        </div>
        <div className="col-span-1 lg:col-span-2">
          {videoFile && (
            <LazyYoutube videoFile={videoFile} />
          )}          
        </div>
        <div className="">
          <div className="text-left">              
              <p className="text-lg text-primary mb-10 ml-0 lg:ml-10">{aboutUsPage.excerpt}</p>
              <a className="mt-2 font-bold underline float-end" href={aboutUsPage.slug.current}>More</a>
          </div>
        </div>
      </div>
    </div>
  );
}
